import { LuPlay, LuPause } from 'react-icons/lu'
import { useState } from 'react'

const row1 = [
  "Women's Health",
  'Medical Herbalism',
  'Fibroid Support',
  'Hormonal Balance',
  'Menopause Care',
  'Clinical Practice',
]

const row2 = [
  'Chronic Conditions',
  'Natural Wellness',
  'Womb Health',
  'Herbal Medicine',
  'Bio-Scan Assessments',
  'Herbal Walks',
]

export const MarqueeStrip = () => {
  const [paused, setPaused] = useState(false)

  return (
    <div className="flex items-center border-b border-base-200 bg-base-100">
      <div className="min-w-0 flex-1 overflow-hidden py-5">
        <div
          className="flex w-max motion-safe:animate-marquee motion-reduce:w-full"
          style={{
            animationDirection: 'reverse',
            animationDuration: '50s',
            animationPlayState: paused ? 'paused' : 'running',
          }}
        >
          {[0, 1].map((copy) => (
            <ul
              key={copy}
              aria-hidden={copy === 1 ? true : undefined}
              className={`flex shrink-0 items-center motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:gap-y-3 ${copy === 1 ? 'motion-reduce:hidden' : ''}`}
            >
              {[...row1, ...row2].map((value) => (
                <li
                  key={value}
                  className="flex shrink-0 items-center gap-4 whitespace-nowrap px-5 text-xs font-medium tracking-wide text-green-800 sm:text-sm"
                >
                  <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-gold-500" />
                  {value}
                </li>
              ))}
            </ul>
          ))}
        </div>
      </div>
      <button
        type="button"
        onClick={() => setPaused((value) => !value)}
        aria-label={paused ? 'Resume scrolling topics' : 'Pause scrolling topics'}
        className="mx-2 inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-base-200 text-green-800 transition-colors hover:bg-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 motion-reduce:hidden"
      >
        {paused ? (
          <LuPlay aria-hidden="true" className="h-4 w-4 shrink-0" />
        ) : (
          <LuPause aria-hidden="true" className="h-4 w-4 shrink-0" />
        )}
      </button>
    </div>
  )
}
